import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { withStyles } from "@material-ui/core/styles";
import Fade from "@material-ui/core/Fade";
import Dialog from "./Dialog";
import FieldGroup from "../FieldGroup";
import { ButtonWillLoad } from "../Buttons";

import { getFreeCopySuccess } from "../../actions";

const styles = theme => ({
  container: {
    padding: 16,
    position: "relative",
    minHeight: 300
  },
  text: {
    lineHeight: "1.6em",
    fontSize: "0.875rem"
  },
  fieldGroup: {
    padding: [[8, 0]]
  },
  buttonContainer: {
    padding: [[8, 0, 16, 0]],
    display: "flex",
    justifyContent: "center"
  },
  successContainer: {
    width: "100%",
    height: "100%",
    top: 0,
    left: 0,
    position: "absolute",
    backgroundColor: "#f2f3f2",
    padding: 16
  }
});
class FreeCopyDialog extends Component {
  state = {
    firstName: "",
    lastName: "",
    email: ""
  };
  handleChange = fieldName => event => {
    this.setState({
      [fieldName]: event.target.value
    });
  };
  handleSubmit = async event => {
    event.preventDefault();
    this.setState({ loading: true });
    const { firstName, lastName, email } = this.state;
    const response = await fetch("/.netlify/functions/free-copy", {
      method: "POST",
      headers: new Headers({
        "Content-Type": "application/json"
      }),
      body: JSON.stringify({
        firstName,
        lastName,
        email
      })
    });
    if (response.status !== 200) {
      // todo
    }
    this.setState({ loading: false, success: true });
    setTimeout(this.props.getFreeCopySuccess, 1200);
  };
  render() {
    const { open, onClose, classes, gotFreeCopy, seeProductLink } = this.props;
    const disabled = this.state.loading;
    return (
      <Dialog
        title="Get a FREE copy"
        label="get-free-copy-dialog"
        open={open}
        onClose={onClose}
      >
        <div className={classes.container}>
          {!this.props.gotFreeCopy && (
            <Fragment>
              <p className={classes.text}>
                Our first 100 customers get a FREE Time Capsule
                (print-it-yourself version). Enter your info and we'll save you
                a spot. After that, gather your photos and create in your
                desktop browser.
              </p>
              <form className={classes.form} onSubmit={this.handleSubmit}>
                <FieldGroup className={classes.fieldGroup}>
                  <input
                    className="field half"
                    name="firstName"
                    placeholder="First Name"
                    value={this.state.firstName}
                    onChange={this.handleChange("firstName")}
                    required={true}
                    disabled={disabled}
                  />
                  <input
                    className="field half"
                    name="lastName"
                    placeholder="Last Name"
                    value={this.state.lastName}
                    onChange={this.handleChange("lastName")}
                    disabled={disabled}
                  />
                  <input
                    className="field"
                    name="email"
                    type="email"
                    placeholder="Email"
                    value={this.state.email}
                    onChange={this.handleChange("email")}
                    required={true}
                    disabled={disabled}
                  />
                </FieldGroup>
                <div className={classes.buttonContainer}>
                  <ButtonWillLoad
                    type="submit"
                    fullWidth={true}
                    variant="contained"
                    loading={this.state.loading}
                    success={this.state.success}
                    successText="Success!"
                    disabled={disabled}
                  >
                    Submit
                  </ButtonWillLoad>
                </div>
              </form>
            </Fragment>
          )}
          {(this.state.success || this.props.gotFreeCopy) && (
            <Fade in={gotFreeCopy} timeout={1000}>
              <div className={classes.successContainer}>
                <p className={classes.text}>
                  Your'll receive a confirmation letter soon. Now start
                  gathering photos for your Time Capsule Mosaic.
                </p>
                {seeProductLink && (
                  <Link to="/products/timecapsule">see our products →</Link>
                )}
              </div>
            </Fade>
          )}
        </div>
      </Dialog>
    );
  }
}
const mapStateToProps = state => ({
  gotFreeCopy: state.getFreeCopySuccess
});
FreeCopyDialog = connect(
  mapStateToProps,
  { getFreeCopySuccess }
)(FreeCopyDialog);
export default withStyles(styles)(FreeCopyDialog);



// WEBPACK FOOTER //
// ./src/components/Dialogs/FreeCopyDialog.js